module.exports = __webpack_public_path__ + "static/media/homeIcon.cde7e6f4.png";